<template>
  <div>
    <spinner v-if="loading"></spinner>
    <p v-if="error" class="text-14 text-danger">
      {{ errorMessage }}
    </p>
    <div v-else-if="!loading" class="relative">
      <div class="flex align-items-center justify-space-between gap-xs m-b-xxs">
        <div class="flex-1 text-12 text-gray-700 metrics-chart-title">
          <label>Memberships by plan</label>
        </div>
        <span v-if="metrics.tooltip" class="print-hide">
          <VDropdown theme="info-tooltip">
            <i class="fa-solid fa-circle-question text-gray-400 text-12"></i>
            <template v-slot:popper>
              <div>
                <p class="m-n p-n" v-text="metrics.tooltip"></p>
              </div>
            </template>
          </VDropdown>
        </span>
      </div>
      <div class="flex gap-x-sm align-items-baseline justify-space-between flex-wrap m-b-sm">
        <div class="flex flex-col">
          <div class="text-blue-700 text-20 font-heavy">{{ metrics.sold_total }} sold</div>
          <div class="text-12 text-gray-500">{{ metrics.interval }}</div>
        </div>
        <div class="text-gray-500 text-12 font-normal flex flex-col text-right">
          <div>
            <span class="text-green-600 font-semi">{{ metrics.new_total }} new</span> ·
            <span class="text-blue-600 font-semi">{{ metrics.renewed_total }} renewed</span> ·
            <span class="text-red-500 font-semi">{{ metrics.cancelled_total }} cancelled</span>
          </div>
          <div>{{ metrics.active_total }} active today</div>
        </div>
      </div>
      <p v-if="!hasRows" class="text-gray-500 text-14 m-b-none">No memberships in this period.</p>
      <div v-else class="table-responsive">
        <table class="table table-condensed m-b-none">
          <thead>
            <tr class="text-12 text-gray-600">
              <th>Plan</th>
              <th>Program</th>
              <th>Term</th>
              <th class="text-right">New</th>
              <th class="text-right">Renewed</th>
              <th class="text-right">Sold</th>
              <th class="text-right">Cancelled</th>
              <th class="text-right">Active today</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in metrics.rows" :key="row.plan_id">
              <td class="text-gray-800 font-semi">
                {{ row.plan_name }}
                <span v-if="!row.plan_active" class="text-gray-400 font-normal">(inactive plan)</span>
              </td>
              <td class="text-gray-600">{{ row.product_name }}</td>
              <td class="text-gray-600">{{ row.term_label }}</td>
              <td class="text-right" :class="row.new_count > 0 ? 'text-green-600 font-semi' : 'text-gray-400'">{{ row.new_count }}</td>
              <td class="text-right" :class="row.renewed_count > 0 ? 'text-blue-600 font-semi' : 'text-gray-400'">{{ row.renewed_count }}</td>
              <td class="text-right text-gray-800 font-heavy">{{ row.new_count + row.renewed_count }}</td>
              <td class="text-right" :class="row.cancelled_count > 0 ? 'text-red-500 font-semi' : 'text-gray-400'">{{ row.cancelled_count }}</td>
              <td class="text-right text-gray-800">{{ row.active_count }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-semi text-gray-800">
              <td colspan="3">All membership plans</td>
              <td class="text-right">{{ metrics.new_total }}</td>
              <td class="text-right">{{ metrics.renewed_total }}</td>
              <td class="text-right font-heavy">{{ metrics.sold_total }}</td>
              <td class="text-right">{{ metrics.cancelled_total }}</td>
              <td class="text-right">{{ metrics.active_total }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { errorableMix } from './mixins/errorable_mix';
import Spinner from './spinner.vue';

// Per-plan companion to the subscription flow chart. Same subscription events,
// sliced by membership plan instead of by month, with renewals added so "sold"
// answers "how many 3-month memberships did we sell?" (see MetricsController#memberships_by_plan).
export default {
  name: 'memberships-by-plan-table',
  mixins: [errorableMix],
  components: { Spinner },
  props: {
    endpoint: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      metrics: {
        rows: [],
        sold_total: 0,
        new_total: 0,
        renewed_total: 0,
        cancelled_total: 0,
        active_total: 0,
        interval: '',
        tooltip: null,
      },
    };
  },
  computed: {
    hasRows() {
      return this.metrics.rows && this.metrics.rows.length > 0;
    },
  },
  mounted() {
    this.loading = true;
    axios.get(this.endpoint)
      .then((response) => {
        this.metrics = response.data.metrics;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.errorMessage = this.parseErrorResponse(error);
        this.error = true;
      });
  },
};
</script>
